import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowLeft, BookOpen } from 'lucide-react';

// The full manual lives as static pages (docs.html / docs-en.html) — this page
// embeds the right one per UI language so there's a single source of truth.
export default function WhatsAppDocs() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const docUrl = (i18n.language || 'es').startsWith('en') ? '/docs-en.html' : '/docs.html';

  return (
    <div className="p-6 space-y-4 h-full flex flex-col" data-testid="whatsapp-docs-page">
      <div className="flex items-center gap-4">
        <Button variant="outline" size="sm" onClick={() => navigate('/whatsapp')}>
          <ArrowLeft className="w-4 h-4 mr-2" /> {t('waDocs.back')}
        </Button>
        <div>
          <h1 className="text-2xl font-bold text-foreground flex items-center gap-2">
            <BookOpen className="w-6 h-6" /> {t('waDocs.title')}
          </h1>
          <p className="text-muted-foreground">{t('waDocs.subtitle')}</p>
        </div>
      </div>
      <iframe
        key={docUrl}
        src={docUrl}
        title={t('waDocs.title')}
        className="w-full flex-1 min-h-[70vh] rounded-lg border border-border bg-white"
      />
    </div>
  );
}
